import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = {
  key: 0,
  class: "nav-btns"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_user_bar = _resolveComponent("user-bar");
  const _component_el_header = _resolveComponent("el-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  const _directive_has = _resolveDirective("has");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [!$setup.hideHeader ? (_openBlock(), _createBlock(_component_el_header, {
      key: 0,
      height: "61px"
    }, {
      default: _withCtx(() => [_ctx.$isClient ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
        size: "mini",
        icon: "el-icon-arrow-left",
        circle: "",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.back()),
        title: "后退"
      }), _createVNode(_component_el_button, {
        size: "mini",
        icon: "el-icon-arrow-right",
        circle: "",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.go(1)),
        title: "前进"
      }), _createVNode(_component_el_button, {
        size: "mini",
        icon: "el-icon-full-screen",
        circle: "",
        onClick: $setup.fullScreenHandler,
        title: "全屏/退出全屏"
      }, null, 8, ["onClick"]), _createVNode(_component_el_button, {
        size: "mini",
        icon: "el-icon-refresh-right",
        circle: "",
        onClick: $setup.reload,
        title: "刷新"
      }, null, 8, ["onClick"])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            class: "logo-img",
            src: require('../../src/assets/images/login/logo_pingtai.png')
          }, null, 8, _hoisted_3)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 18
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
            class: "logo-text"
          }, "宣传素材管理平台", -1)]))]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(_component_el_menu, {
        "default-active": $setup.defaultActive,
        class: "el-menu-demo",
        mode: "horizontal",
        router: true,
        onSelect: $setup.handleSelect,
        "background-color": "#fefefe",
        "text-color": "#545454",
        "active-text-color": "#4696F8"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.headerMenus, item => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.name
          }, [item.meta.permission === 'position' ? _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            key: 0,
            index: $setup.positionPath
          }, {
            default: _withCtx(() => [item.path == $setup.defaultActive ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item.meta.activeIcon,
              class: "menu-icon"
            }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: item.meta.icon,
              class: "menu-icon"
            }, null, 8, _hoisted_5)), _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
            _: 2
          }, 1032, ["index"])), [[_directive_has, item.meta.permission]]) : _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            index: item.path
          }, {
            default: _withCtx(() => [item.path == $setup.defaultActive ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item.meta.activeIcon,
              class: "menu-icon"
            }, null, 8, _hoisted_6)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: item.meta.icon,
              class: "menu-icon"
            }, null, 8, _hoisted_7)), _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
            _: 2
          }, 1032, ["index"])), [[_directive_has, item.meta.permission]])], 64);
        }), 128))]),
        _: 1
      }, 8, ["default-active", "onSelect"]), _createVNode(_component_user_bar, {
        class: "user-bar"
      })]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_container, null, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_router_view, {
        name: "aside"
      })], 512), [[_vShow, !$setup.hideAside]]), _createVNode(_component_el_main, {
        class: _normalizeClass(['custom-scroll-bar', {
          'blue-bg': $setup.blueBg
        }])
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["class"])]),
      _: 1
    })]),
    _: 1
  })]);
}